<template>
  <div class="content-scoll">
    <div class="pupils-card border-white">
      <div>
        <!-- <h5 v-if="group_id">{{ 'online_chat' | setText('Онлайн-чат') }}</h5> -->
        <ul class="pupils-list">
          <li 
            @click="clientCurrent = client" 
            :class="`${clientCurrent && client.id == clientCurrent.id ? 'active' : ''}`"
            v-for="client in clients" :key="client.id"
            class="pupils-list-item"
            :style="`--color-card: #bfd6ff`"
          >
            <div><img :src="client.avatar" /></div> <span>{{ client.full_name }} </span>
            <div v-if="client.badge" class="badge">
              <span>{{ client.badge }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="area">
        <chat-area v-if="clientCurrent" :client="clientCurrent" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import ChatArea from '@/components/Pupils/Chat/ChatArea';
import { getClients } from '@/_api/apiPupil';
export default {
  props: {
    group_id: {
      default: null
    }
  },
  computed: {
    ...mapState(['message', 'badge'])
  },
  components: {
    ChatArea
  },
  mounted() {

 

  },
  created() {
    this.getClients(this.group_id);
  },
  watch: {
    group_id(val) {
      this.clientCurrent = null;
      this.getClients(val);
    },
  },
  methods: {
    getClients: getClients
  },
  data() {
    return {
      clients: [],
      clientCurrent: null,
    };
  },
  watch: {
    clientCurrent(val) {
      if (val.chat) {
        for (let i = 0; i < this.clients.length; i++) {
          if (this.clients[i].chat.id == val.chat.id) {
            // this.$store.dispatch("setBadge", this.badge - val.badge);
            this.clients[i].badge = 0;
            //send on read socket.
          }
        }
      }
    },
    message: {
      handler: function (val) {
        // if (val && val.chat) {
          // for (let i = 0; i < this.clients.length; i++) {
          //   if (this.clientCurrent && this.clientCurrent.chat && this.clientCurrent.chat.id && this.clientCurrent.chat.id == this.clients[i].chat.id && this.clients[i].chat.id == val.chat.id) {
          //     this.clients[i].badge = 0;
          //     continue;
          //   }
          //   if (this.clients[i].chat.id == val.chat.id) {
          //     this.clients[i].badge = val.chat.badge;
          //   }
          // }
        // }
      },
      deep: true,
    },
  }
};
</script>
